<template>
  <div class="deviceManageBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>电场仪管理</span>
      </div>
      <el-table :data="deviceList" style="width: 100%" height="650">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
        <el-table-column prop="deviceId" label="设备ID" width="160"></el-table-column>
        <el-table-column label="所属区域" width="160">
          <template slot-scope="scope">
            {{ getRegionName(scope.row.deviceCode) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="deviceTypeName" label="设备类型"></el-table-column> -->
        <el-table-column prop="lon" label="经度" width="100"></el-table-column>
        <el-table-column prop="lat" label="纬度" width="100"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="showEditDialog(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="修改电场仪" :visible.sync="isShowEditDialog">
      <el-form :model="editData">
        <el-form-item label="设备名称：" label-width="120px">
          <el-input v-model="editData.deviceName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="设备ID：" label-width="120px">
          <el-input v-model="editData.deviceId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属区域：" label-width="120px">
          <el-select v-model="editData.deviceCode" style="width:100%">
            <el-option
              v-for="(name, code) in regionMap"
              :key="code"
              :label="name"
              :value="code"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备类型：" label-width="120px">
          <el-input v-model="editData.deviceTypeName" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="经度：" label-width="120px">
          <el-input v-model="editData.lon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纬度：" label-width="120px">
          <el-input v-model="editData.lat" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deviceList: [],
      isShowEditDialog: false,
      editData: {},
      regionMap: {
        '1': '阿克苏气象局',
        '2': '拜城工业园区',
        '3': '温宿产业园区',
        '4': '沙雅工业园区',
        '5': '新和县工业园区（西区）'
      }
    };
  },
  created() {
    this.getDeviceList();
  },
  methods: {
    getRegionName(code) {
      return this.regionMap[code] || code;
    },
    getDeviceList() {
      this.$axios({
        method: "get",
        url: `${this.$url2}/station/list`
      }).then((res) => {
        console.log("电场仪列表返回结果:", res.data);
        if (res.data.success) {
          this.deviceList = res.data.data;
        }
      });
    },
    showEditDialog(row) {
      this.editData = { ...row };
      this.isShowEditDialog = true;
    },
    submitEdit() {
      this.$axios({
        method: "put",
        url: `${this.$url2}/station/${this.editData.id}`,
        data: this.editData
      }).then((res) => {
        console.log("修改电场仪返回结果:", res.data);
        if (res.data.success) {
          this.$message({ message: '修改成功', type: 'success' });
          this.isShowEditDialog = false;
          this.getDeviceList();
        }
      });
    }
  }
};
</script>

<style scoped>
.deviceManageBody {
  width: 100%;
  min-height: calc(100vh - 84px);
  padding: 15px;
}
</style>
